<custom-table [config]="customTable">
</custom-table>

<section>
  <p-confirmPopup></p-confirmPopup>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true"
      [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '60vw'}">

      <ng-template pTemplate="header">
        <CustomTitle [title]="formTitle" />
      </ng-template>

      <ng-template pTemplate="content">
        <div class="grid formgrid p-fluid">
          <div class="field col-12">
            <label class="ml-3" for="codificacion">{{trans.codificacion}}<span style="color: red">*</span></label>
            <input pInputText formControlName="codificacion" id="codificacion" type="text" />
            <ng-container *ngIf="form.get('codificacion')?.invalid && form.get('codificacion')?.touched">
              <app-form-group-error-message [control]="form.get('codificacion')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12">
            <label class="ml-3" for="descripcion">{{trans.descripcion}}<span style="color: red">*</span></label>
            <input pInputText formControlName="descripcion" id="descripcion" type="text" />
            <ng-container *ngIf="form.get('descripcion')?.invalid && form.get('descripcion')?.touched">
              <app-form-group-error-message [control]="form.get('descripcion')"></app-form-group-error-message>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <div class="field col-12">
          <div class="flex justify-content-between">
            <button pButton type="button" [label]="trans.limpiar" iconPos="right" icon="pi pi-eraser"
              class="tax-app-button" class="tax-app-button" (click)="resetForm()"></button>
            <button pButton type="submit" [label]="trans.guardar" icon="pi pi-save" iconPos="right"
              class="tax-app-button" class="tax-app-button" [disabled]="!ls.hasRole(role.ADMIN_SEC)"></button>
          </div>
        </div>
      </ng-template>
    </p-dialog>

  </form>
</section>

<app-permisos-historico></app-permisos-historico>